import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/catalog')({
  component: CatalogLayout,
})

function CatalogLayout() {
  return <Outlet />
}
